import { createAction, props } from '@ngrx/store';
import { PhotoGallery } from '@models/photo-gallery.model';

export enum PhotoGalleryActions {
  CREATE_PHOTO_GALLERY = '[Photo Galleries] Create photo gallery',
  CREATE_PHOTO_GALLERY_SUCCESS = '[Photo Galleries] Photo gallery created',
  CREATE_PHOTO_GALLERY_FAILED = '[Photo Galleries] Cannot create photo gallery',
  GET_PHOTO_GALLERIES = '[Photo Galleries] Get photo galleries',
  GET_PHOTO_GALLERIES_SUCCESS = '[Photo Galleries] Photo galleries fetched',
  GET_PHOTO_GALLERIES_FAILED = '[Photo Galleries] Cannot fetch photo galleries',
  UPDATE_PHOTO_GALLERY = '[Photo Galleries] Update photo gallery',
  UPDATE_PHOTO_GALLERY_SUCCESS = '[Photo Galleries] Photo gallery updated',
  UPDATE_PHOTO_GALLERY_FAILED = '[Photo Galleries] Cannot update photo gallery',
  DELETE_PHOTO_GALLERY = '[Photo Galleries] Delete photo gallery',
  DELETE_PHOTO_GALLERY_SUCCESS = '[Photo Galleries] Photo gallery deleted',
  DELETE_PHOTO_GALLERY_FAILED = '[Photo Galleries] Cannot delete photo gallery'
}

export const fetchPhotoGalleries = createAction(PhotoGalleryActions.GET_PHOTO_GALLERIES);
export const photoGalleriesFetched = createAction(PhotoGalleryActions.GET_PHOTO_GALLERIES_SUCCESS, props<{
  payload: PhotoGallery[]
}>());
export const cannotFetchPhotoGalleries = createAction(PhotoGalleryActions.GET_PHOTO_GALLERIES_FAILED, props<{
  error: string
}>());

export const updatePhotoGallery = createAction(PhotoGalleryActions.UPDATE_PHOTO_GALLERY, props<{
  payload: PhotoGallery
}>());
export const photoGalleryUpdated = createAction(PhotoGalleryActions.UPDATE_PHOTO_GALLERY_SUCCESS, props<{
  payload: PhotoGallery
}>());
export const cannotUpdatePhotoGallery = createAction(PhotoGalleryActions.UPDATE_PHOTO_GALLERY_FAILED, props<{
  error: string
}>());

export const createPhotoGallery = createAction(PhotoGalleryActions.CREATE_PHOTO_GALLERY, props<{
  payload: PhotoGallery
}>());
export const photoGalleryCreated = createAction(PhotoGalleryActions.CREATE_PHOTO_GALLERY_SUCCESS, props<{
  payload: PhotoGallery
}>());
export const cannotCreatePhotoGallery = createAction(PhotoGalleryActions.CREATE_PHOTO_GALLERY_FAILED, props<{
  error: string
}>());

export const deletePhotoGallery = createAction(PhotoGalleryActions.DELETE_PHOTO_GALLERY, props<{ payload: string }>());
export const photoGalleryDeleted = createAction(PhotoGalleryActions.DELETE_PHOTO_GALLERY_SUCCESS, props<{
  payload: string
}>());
export const cannotDeletePhotoGallery = createAction(PhotoGalleryActions.DELETE_PHOTO_GALLERY_FAILED, props<{
  error: string
}>());
